export default "__VITE_ASSET__DmIpNcw6__"